import { Component, ViewChild, ElementRef, Output, Input, EventEmitter, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TextInput } from '@aileron/text-input';
import { ErrorNotification, FlightStatusService } from '@modules/flight-status/flight-status.service';
import { environment } from 'env';
import { DatePipe } from '@angular/common';
import { DataCollectionClientService } from '@core/services/data-collection-client.service';

@Component({
  selector: 'hp-flight-number',
  templateUrl: './flight-number.component.html',
  styleUrls: ['./flight-number.component.scss']
})
export class FlightNumberComponent implements AfterViewInit {

    private readonly _flightNumberEndPoint = environment.flightStatus.flightNumberEndPoint;
    errorCount: number = 0;
    showFormValue = environment.showFormValue;
    submittedForm = '';
    dates: Array<any>;
    errorMessage: ErrorNotification;
    flightNumberForm: FormGroup;
    @ViewChild('flightNumber') flightNumberValidation: TextInput;
    @ViewChild('flightNumber', { read: ElementRef}) flightNumber: ElementRef;
    @ViewChild('flightNumberDate', { read: ElementRef}) flightNumberDate: ElementRef;
    @Input() loadingState: boolean;
    @Output() loadingStateChanged: EventEmitter<boolean> =   new EventEmitter();


    constructor(
        private _flightStatusService: FlightStatusService,
        public datePipe: DatePipe,
        private _window: Window,
        private _dataCollectionClient: DataCollectionClientService
    ) {
        this.flightNumberForm = new FormGroup({
                flightNumber: new FormControl('', Validators.required),
                flightNumberDate: new FormControl()
            })
    }

    ngAfterViewInit(): void {
        this.setDates(this._flightStatusService.dates);
    }

    ngOnInit(): void {
        const styleInnerHtml =
                `:host .adc-text-input__input[type=number]::-webkit-inner-spin-button,
                :host .adc-text-input__input[type=number]::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                :host .adc-text-input__input[type=number] {
                    -moz-appearance: textfield;
                }`

        if(document.getElementById('flightNumberInput').shadowRoot.querySelector('style')){
            document.getElementById('flightNumberInput').shadowRoot.querySelector('style').append(styleInnerHtml);
        }
        else{
            const style = document.createElement('style');
            style.innerHTML = styleInnerHtml;
            document.getElementById('flightNumberInput').shadowRoot.append(style);
        }

    }

    generateFlightNumberUrl() {

        const flightDate = this.datePipe.transform(this.flightNumberForm.controls.flightNumberDate.value,'yyyy,MM,dd');
        const flightNumberSearchUrl = this._flightNumberEndPoint+this.flightNumberForm.controls.flightNumber.value+'|'+flightDate+'&ref=search';
        return flightNumberSearchUrl;

    }

    submitForm(inputForm: FormGroup) {
        this._flightStatusService.errorIDs = [];
        this.loadingState = true;
        this.loadingStateChanged.emit(this.loadingState);
        this.submittedForm = JSON.stringify(inputForm.value);

        if (inputForm.valid) {
            this._window.location.assign(this.generateFlightNumberUrl());
        } else {
            this.loadingState = false;
            this.loadingStateChanged.emit(this.loadingState);
            this._flightStatusService.setErrorMessages(
                inputForm.controls['flightNumber'],
                this.flightNumberValidation,
                {requiredMessage: { text: this._flightStatusService.translate('error:ERRCODE1218'), code: 'ERRCODE1218' }}
            );
            this.errorCount = this._flightStatusService.errorIDs.length;
            this.errorMessage = this._flightStatusService.getNotificationMessage(this.errorCount);
            this.updateDCFData();
        }
    }

    focusFirstError() {
        if (this.flightNumberForm.controls['flightNumber'].errors) {
            this.flightNumber.nativeElement.shadowRoot.querySelector('input').focus();
        }
    }

    updateFlightNumber(){
        this.flightNumberForm.get('flightNumber').patchValue(this.flightNumber.nativeElement.shadowRoot.querySelector('input').value);
    }

    keyPressNumber(event) {
        if (event.key === 'Backspace' || /[0-9]/.test(event.key) || event.key === 'Tab') {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    setDates(dates: Array<any>) {
        if (dates) {
            this.dates = dates.slice();
            this.flightNumberForm.controls['flightNumberDate'].setValue(this.dates[2].value);
        }
    }

    updateDCFData() {
        const errorDCFData = {
            page_name: 'Flight Status Webcomponent',
            channel: 'Homepage',
            page_action: 'Flight Number Form Submit',
            error_id: this._flightStatusService.errorIDs.toString()
        };
        this._dataCollectionClient.updateAnalytics(errorDCFData, 'Error Call', 'link');
    }
}
